import Vue from 'vue'

import "core-js/stable";
import "regenerator-runtime/runtime";
import AppLayout from './layout/Index.vue'
import router from './router'
import axios from 'axios'
import plugins from './plugins/index.js'
import VueAxios from 'vue-axios'
import VueScrollTo from 'vue-scrollto';
import Sortable from './mixins/sortable.js'
import VCalendar from 'v-calendar';
import CKEditor from '@ckeditor/ckeditor5-vue2';


import { BootstrapVue } from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faArrowsAlt } from '@fortawesome/free-solid-svg-icons'
import { faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { faCaretUp } from '@fortawesome/free-solid-svg-icons'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { faCog } from '@fortawesome/free-solid-svg-icons'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { faFileAlt } from '@fortawesome/free-solid-svg-icons'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { faChartLine } from '@fortawesome/free-solid-svg-icons'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { faSync} from '@fortawesome/free-solid-svg-icons'
import { faSitemap } from '@fortawesome/free-solid-svg-icons'
import { faTag } from '@fortawesome/free-solid-svg-icons'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { faUsers } from '@fortawesome/free-solid-svg-icons'
import { faObjectGroup } from '@fortawesome/free-solid-svg-icons'
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons'
import { faCartArrowDown } from '@fortawesome/free-solid-svg-icons'
import { faColumns } from '@fortawesome/free-solid-svg-icons'
import { faUserFriends } from '@fortawesome/free-solid-svg-icons'
import { faComment } from '@fortawesome/free-solid-svg-icons'
import { faComments } from '@fortawesome/free-solid-svg-icons'
import { faProjectDiagram } from '@fortawesome/free-solid-svg-icons'
import { faUserLock } from '@fortawesome/free-solid-svg-icons'
import { faChartPie } from '@fortawesome/free-solid-svg-icons'
import { faClipboardList } from '@fortawesome/free-solid-svg-icons'
import { faBook } from '@fortawesome/free-solid-svg-icons'
import { faFlag } from '@fortawesome/free-solid-svg-icons'
import { faUserGraduate } from '@fortawesome/free-solid-svg-icons'
import { faCaretSquareDown } from '@fortawesome/free-solid-svg-icons'
import { faCaretSquareRight } from '@fortawesome/free-solid-svg-icons'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'



import {utilities} from './mixins/index.js'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/fonts.css'
import './assets/main.css'

Vue.config.productionTip=false;

if (window.location.origin.indexOf("admin.simmersion.com")>-1) {
  Vue.prototype.$hostname = "https://tcapi.simmersion.net";
  Vue.prototype.$lifeline_user_validation_url = "https://learning.988lifeline.org/webservice/rest/server.php?wstoken=30efbbf87e69e33b1e927d17e9148e6e&wsfunction=theme_illumina_get_user_details&moodlewsrestformat=json";
}
else {
  //Vue.prototype.$hostname = "http://localhost:62377";
  Vue.prototype.$hostname = "https://tcapi.simmersionstage.net";
  Vue.prototype.$lifeline_user_validation_url = "https://suicidepreventionlifeline.sebale.net/webservice/rest/server.php?wstoken=30efbbf87e69e33b1e927d17e9148e6e&wsfunction=theme_illumina_get_user_details&moodlewsrestformat=json";
}

library.add(faArrowUp);
library.add(faArrowDown);
library.add(faArrowLeft);
library.add(faArrowsAlt);
library.add(faCaretDown);
library.add(faCaretUp);
library.add(faCheckCircle);
library.add(faCog);
library.add(faEdit);
library.add(faCopy);
library.add(faFileAlt);
library.add(faFilter);
library.add(faEnvelope);
library.add(faInfoCircle);
library.add(faChartLine);
library.add(faPlus);
library.add(faQuestionCircle);
library.add(faSync);
library.add(faSitemap);
library.add(faTag);
library.add(faTimes);
library.add(faTimesCircle);
library.add(faTrash);
library.add(faUser);
library.add(faUsers);

library.add(faObjectGroup);
library.add(faAngleDoubleRight);
library.add(faCartArrowDown);
library.add(faColumns);
library.add(faUserFriends);
library.add(faComment);
library.add(faComments);
library.add(faProjectDiagram);
library.add(faUserLock);
library.add(faChartPie);
library.add(faClipboardList);
library.add(faBook);
library.add(faFlag);
library.add(faUserGraduate);
library.add(faCaretSquareDown);
library.add(faCaretSquareRight);
library.add(faBars);
library.add(faSearch);

Vue.mixin(utilities);

Vue.use(VueScrollTo, {
  container: "body",
  duration: 300,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: false,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});
Vue.use(CKEditor);
Vue.use(VCalendar)
Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('wondertree', require('./components/WonderTree.vue').default);

// Adapted from https://codepen.io/zupkode/pen/VgbRdQ
Vue.directive("draggable", {
  //adapted from https://codepen.io/kminek/pen/pEdmoo
  inserted: function(el, binding, a) {
    Sortable.create(el, {
      draggable: ".draggable",
      onEnd: function(e) {
        /* vnode.context is the context vue instance: "This is not documented as it's not encouraged to manipulate the vm from directives in Vue 2.0 - instead, directives should be used for low-level DOM manipulation, and higher-level stuff should be solved with components instead. But you can do this if some usecase needs this. */
        // fixme: can this be reworked to use a component?
        // https://github.com/vuejs/vue/issues/4065
        // https://forum.vuejs.org/t/how-can-i-access-the-vm-from-a-custom-directive-in-2-0/2548/3
        // https://github.com/vuejs/vue/issues/2873 "directive interface change"
        // `binding.expression` should be the name of your array from vm.data
        // set the expression like v-draggable="items"
        var clonedItems = a.context[binding.expression].filter(function(item) {
          return item;
        });
        clonedItems.splice(e.newIndex, 0, clonedItems.splice(e.oldIndex, 1)[0]);
        var wdata = JSON.parse(localStorage.getItem("wdata"));
        var nwdata=[];
        for(var item of clonedItems) {
          var m = wdata[item.wtid].filter(p=>p.id===item.id);
          nwdata.push(m[0]);
        }
        wdata[clonedItems[0].wtid]=nwdata;
        localStorage.setItem("wdata",JSON.stringify(wdata));
        a.context[binding.expression] = [];
        Vue.nextTick(function() {
          a.context[binding.expression] = clonedItems;
        });
        
      }
    });
  }
});

new Vue({
  name: 'Root',
  router,
  render: h => h(AppLayout)
}).$mount('#app');
